export default "__VITE_ASSET__6279b51e__"